const Config = {
    // It can be here, or if you want change it to the .env file
    // API_URL: "http://54.167.3.110/api/",
    // API_URL: "http://127.0.0.1:8000/api/",
    API_URL: "https://hubreserve.software/api/",
}

export default Config;